import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddressSearchPage from './pages/AddressSearchPage';
import ResultsPage from './pages/ResultsPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AddressSearchPage />} />
        <Route path="/results/:buildingId" element={<ResultsPage />} />
      </Routes>
    </Router>
  );
};

export default App;